// src/i18n/index.js — i18next Konfiguration
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './de.json';
import en from './en.json';
import it from './it.json';
import cs from './cs.json';
import sk from './sk.json';
import fr from './fr.json';
import es from './es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      it: { translation: it },
      cs: { translation: cs },
      sk: { translation: sk },
      fr: { translation: fr },
      es: { translation: es },
    },
    fallbackLng: 'de',
    supportedLngs: ['de', 'en', 'it', 'cs', 'sk', 'fr', 'es'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'tda-lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
